export const formatPhoneNumber = (phoneNumberString: string) => {
	const formattedPhoneNumber = phoneNumberString.replace("+46", "0");

	if (!formattedPhoneNumber) {
		return "Okänt telefonnummer";
	}
	return formattedPhoneNumber;
};
